
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.66 1.668a.833.833 0 00-.834.834v.53a7.53 7.53 0 01-5.833 2.803h-5a2.503 2.503 0 00-2.5 2.5V10a2.503 2.503 0 002.5 2.5h.403l-2.002 4.673a.833.833 0 00.765 1.16h3.334a.833.833 0 00.765-.505l2.27-5.296a7.523 7.523 0 015.298 2.771v.53a.833.833 0 101.667 0V2.503a.835.835 0 00-.834-.834zM4.992 10.835A.834.834 0 014.159 10V8.335a.834.834 0 01.834-.833h.833v3.333h-.833zm1.95 5.833h-1.52l1.786-4.166h1.52l-1.786 4.166zm8.883-3.732a9.21 9.21 0 00-5.833-2.101h-2.5V7.5h2.5A9.21 9.21 0 0015.826 5.4v7.536z","fill":"#3254EC"}})])
          )
        }
      }
    